<div class="trend-chart">
  <div class="trend-chart__header">
    <div>
      <div class="trend-chart__title">{{ "data-platform.trend-title" | translate: { days: lookbackDays } }}</div>
      <div class="trend-chart__sub">{{ "data-platform.trend-sub" | translate }}</div>
    </div>
    <div class="trend-chart__pills">
      @if (latestValue() !== null) {
        <span class="legend-pill">
          {{ "data-platform.trend-today" | translate }}
          <strong>{{ latestValue() | toLocaleNumber }}</strong>
        </span>
      }
      @if (delta(); as d) {
        <span class="legend-pill" [class.legend-pill--up]="d.up" [class.legend-pill--down]="!d.up">
          <mat-icon>{{ d.up ? "arrow_upward" : "arrow_downward" }}</mat-icon>
          {{ d.up ? "+" : "-" }}{{ d.percent }}% · {{ lookbackDays }}d
        </span>
      }
      @if (estimated()) {
        <span class="legend-pill legend-pill--estimate" matTooltip="{{ 'data-platform.trend-estimated-tooltip' | translate }}">
          <mat-icon>insights</mat-icon>
          {{ "data-platform.trend-estimated" | translate }}
        </span>
      }
      @if (bestEffort()) {
        <span class="legend-pill legend-pill--warn" matTooltip="{{ 'data-platform.trend-best-effort-tooltip' | translate }}">
          <mat-icon>warning</mat-icon>
          {{ "data-platform.trend-best-effort" | translate }}
        </span>
      }
    </div>
  </div>

  @if (loading()) {
    <div class="trend-chart__loading">
      <mat-spinner diameter="24"></mat-spinner>
    </div>
  } @else if (errored()) {
    <div class="trend-chart__error">
      <mat-icon>error_outline</mat-icon>
      <span>{{ "data-platform.trend-error" | translate }}</span>
      <button mat-stroked-button (click)="retry()">
        <mat-icon>refresh</mat-icon>
        {{ "generic.retry" | translate }}
      </button>
    </div>
  } @else if (chartConfig()) {
    <div class="trend-chart__canvas-wrap">
      <canvas
        baseChart
        [type]="'line'"
        [data]="chartConfig()!.data"
        [options]="chartConfig()!.options"
        [attr.aria-label]="'data-platform.trend-title' | translate: { days: lookbackDays }"></canvas>
    </div>
  } @else {
    <div class="trend-chart__empty">
      <mat-icon>show_chart</mat-icon>
      <span>{{ "data-platform.trend-empty" | translate }}</span>
    </div>
  }
</div>
